<template>
  <div class="humanizacion">
    <span class="texTyping">    
    </span>
      <Dots />
    </div>
</template>
  
  <script>

  import Dots from "./Dots";
  export default {
    name: "ContentHumanizacion",
    components: {
      Dots,
    },
  };

  </script>
  
  <style scoped>
  .humanizacion{
    display: none;
    height: 34px;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 1000;
    font-size: 13px;
    box-shadow: 0 -3px 8px -1px rgba(120, 120, 120, 0.12);
    background-color: #fff;
    border-radius: 0 0 12px 12px;
    color: rgba(120, 120, 120, 1);
    bottom: 0;
    position: absolute;
  }
  .texTyping {
    width: fit-content;
    text-align: right;
  }
  
  </style>


// WEBPACK FOOTER //
// ContentHumanizacion.vue?25150bc8